<template>
  <section id="Achievments">
    <b-row>
      <b-col lg="12">
        <h3 class="text-warning">Achivment</h3>
        <hr />
      </b-col>
      <b-col class="px-50" lg="12">
        <div class="dark-layout card d-flex flex-row px-2 py-1">
          <div style="z-index: 10">
            <b-img :src="require('@/assets/images/new-images-fx/img-8.svg')">
            </b-img>
          </div>
          <div class="ml-1 d-flex align-items-center" style="z-index: 10">
            <h6 class="mb-0">General</h6>
            <!-- <p class="mb-0">SubTitle</p> -->
          </div>
          <div
            class="position-absolute top-0 left-0 w-100 h-100 gradientgeneral"
            style="border-radius: 12px"
          ></div>
        </div>
      </b-col>
      <div
        class="d-flex flex-wrap w-100 pt-1 justify-content-center"
        v-if="loading"
      >
        <b-col v-for="i in 4" :key="i" class="col-md col-6 py-md-1">
          <b-skeleton width="100%" height="250px" />
        </b-col>
      </div>
      <div
        class="d-flex flex-wrap justify-content-center align-items-center align-self-stretch w-100 my-50 my-md-0"
        v-else
      >
        <b-col class="px-50 py-0 col-md col-4 py-md-0">
          <div
            class="card w-100 justify-content-center align-items-center text-align-center py-2"
            :class="
              scores.ADD_AVATAR && scores.ADD_AVATAR.length ? 'Active' : ''
            "
          >
            <div style="" class="BoxImg card-img-to p-2 mt-4">
              <b-img
                :src="require('@/assets/images/new-images-fx/img-6.svg')"
                alt=""
                class="modalImg"
              />
            </div>
            <div class="card-body mt-1 text-white px-50">
              <h3 class="card-text">Avatar</h3>
            </div>
          </div>
        </b-col>

        <b-col class="px-50 py-0 col-md col-4 py-md-0">
          <div
            class="card w-100 justify-content-center align-items-center text-align-center py-2"
            :class="
              scores.First_COMPETITION && scores.First_COMPETITION.length
                ? 'Active'
                : ''
            "
          >
            <div style="" class="BoxImg card-img-to p-2 mt-4">
              <b-img
                :src="require('@/assets/images/new-images-fx/img-5.svg')"
                fluid
                class="modalImg"
              />
            </div>
            <div class="card-body mt-1 text-white px-50">
              <h3 class="card-text">first competition</h3>
            </div>
          </div>
        </b-col>

        <b-col class="px-50 py-0 col-md col-4 py-md-0">
          <div
            class="card w-100 justify-content-center align-items-center text-align-center py-2"
            :class="
              scores.COMPLETE_PROFILE && scores.COMPLETE_PROFILE.length
                ? 'Active'
                : ''
            "
          >
            <div style="" class="BoxImg card-img-to p-2 mt-4">
              <b-img
                :src="require('@/assets/images/new-images-fx/img-4.svg')"
                fluid
                class="modalImg"
              />
            </div>
            <div class="card-body mt-1 text-white px-50">
              <h3 class="card-text">complete profile</h3>
            </div>
          </div>
        </b-col>
      </div>
      <medal-row
        title="join competition"
        type="JOIN_COMPETITION"
        :value="scores.JOIN_COMPETITION"
        :loading="loading"
        imgTitle="img-2.svg"
        imgModal="img-2.svg"
      />
      <medal-row
        title="first place demo trading competition"
        type="FIRST_PLACE_DEMO_TRADING_COMPETITION"
        :value="scores.FIRST_PLACE_DEMO_TRADING_COMPETITION"
        :loading="loading"
        imgTitle="img-2.svg"
        imgModal="img-2.svg"
      />
      <medal-row
        title="first place live trading competition"
        type="FIRST_PLACE_LIVE_TRADING_COMPETITION"
        :value="scores.FIRST_PLACE_LIVE_TRADING_COMPETITION"
        :loading="loading"
        imgTitle="img-2.svg"
        imgModal="img-2.svg"
      />
      <medal-row
        title="second place demo trading competition"
        type="SECOND_PLACE_DEMO_TRADING_COMPETITION"
        :value="scores.SECOND_PLACE_DEMO_TRADING_COMPETITION"
        :loading="loading"
        imgTitle="img-3.svg"
        imgModal="img-3.svg"
      />
      <medal-row
        title="second place live trading competition"
        type="SECOND_PLACE_LIVE_TRADING_COMPETITION"
        :value="scores.SECOND_PLACE_LIVE_TRADING_COMPETITION"
        :loading="loading"
        imgTitle="img-3.svg"
        imgModal="img-3.svg"
      />
      <medal-row
        title="third place demo trading competition"
        type="THIRD_PLACE_DEMO_TRADING_COMPETITION"
        :value="scores.THIRD_PLACE_DEMO_TRADING_COMPETITION"
        :loading="loading"
        imgTitle="img-4.svg"
        imgModal="img-4.svg"
      />
      <medal-row
        title="third place live trading competition"
        type="THIRD_PLACE_LIVE_TRADING_COMPETITION"
        :value="scores.THIRD_PLACE_LIVE_TRADING_COMPETITION"
        :loading="loading"
        imgTitle="img-4.svg"
        imgModal="img-4.svg"
      />
      <medal-row
        title="forth to tenth place demo trading competition"
        type="FOURTH_TO_TENTH_PLACE_DEMO_TRADING_COMPETITION"
        :value="scores.FOURTH_TO_TENTH_PLACE_DEMO_TRADING_COMPETITION"
        :loading="loading"
        imgTitle="img-5.svg"
        imgModal="img-5.svg"
      />
      <medal-row
        title="forth to tenth place live trading competition"
        type="FOURTH_TO_TENTH_PLACE_LIVE_TRADING_COMPETITION"
        :value="scores.FOURTH_TO_TENTH_PLACE_LIVE_TRADING_COMPETITION"
        :loading="loading"
        imgTitle="img-5.svg"
        imgModal="img-5.svg"
      />
      <medal-row
        title="charge"
        type="CHARGE"
        :value="scores.CHARGE"
        :loading="loading"
        imgTitle="img-6.svg"
        imgModal="img-6.svg"
      />
      <medal-row
        title="reach trade"
        type="REACH_TRADE"
        :value="scores.REACH_TRADE"
        :loading="loading"
        imgTitle="img-7.svg"
        imgModal="img-7.svg"
      />
      <medal-row
        title="user experience"
        type="USER_EXPERIENCE"
        :value="scores.USER_EXPERIENCE"
        :loading="loading"
        imgTitle="img-8.svg"
        imgModal="img-8.svg"
      />
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol, BImg, BSkeleton } from "bootstrap-vue";
import MedalRow from "./MedalRow.vue";
export default {
  components: {
    BRow,
    BCol,
    BImg,
    BSkeleton,
    MedalRow,
  },
  data() {
    return {
      scores: "",
      details: "",
      loading: false,
    };
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
  created() {
    this.getUserScore();
  },
  methods: {
    async getUserScore() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(`/panel/profile/user/scores`);
        this.scores = data.scores;
        this.details = data.details;

        // this.dataScore.data.filter((data) => {
        //   data.type == "CHARGE"
        //     ? (this.dataScore.CHARGE = data.total)
        //     : data.type == "PER_WIN_TRADE"
        //     ? (this.dataScore.PER_WIN_TRADE = data.total)
        //     : data.type == "ADD_AVATAR"
        //     ? (this.dataScore.ADD_AVATAR = data.total)
        //     : data.type == "JOIN_COMPETITION"
        //     ? (this.dataScore.JOIN_COMPETITION = data.total)
        //     : data.type == "REACH_TRADE"
        //     ? (this.dataScore.REACH_TRADE = data.total)
        //     : data.type == "ENDED_COMPETITION"
        //     ? (this.dataScore.ENDED_COMPETITION = data.total)
        //     : data.type == "WIN_COMPETITION"
        //     ? (this.dataScore.WIN_COMPETITION = data.total)
        //     : data.type == "VERIFY_ACCOUNT"
        //     ? (this.dataScore.VERIFY_ACCOUNT = data.total)
        //     : null;
        // });

        this.loading = false;
      } catch (err) {}
    },
  },
};
</script>

<style lang="scss">
.Active {
  .BoxImg {
    background: transparent linear-gradient(160deg, #282833 0%, #15182508 100%);
    border-radius: 30px;
  }
  h3 {
    color: white !important;
  }
  .modalImg {
    filter: grayscale(0%);
  }
}
.BoxImg {
  border-radius: 30px;
}
h3 {
  color: #868686 !important;
}
.gradientgeneral {
  background: transparent
    linear-gradient(219deg, #21212100 0%, #31344800 50vw, #39a4f8 112%) 0% 0%
    no-repeat padding-box;
}
.modalImg {
  filter: grayscale(100%);
}
</style>
